import { Link } from "react-router-dom";
import { Box, Button, Container, Paper, Typography } from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

const STAFF_USER_TYPES = new Set(["admin", "employee", "employee_admin", "coach_admin", "coach", "coach_employee"]);

const ProgramFail = () => {
  const userType = localStorage.getItem("userType") || "";
  const isStaff = STAFF_USER_TYPES.has(userType);

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: "center" }}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
          <CancelOutlinedIcon sx={{ fontSize: 72, color: "warning.main" }} />
          <Typography variant="h4" component="h1">
            Registration Cancelled
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Your payment was cancelled. You can try again or contact support.
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, justifyContent: "center", mt: 2 }}>
            {isStaff ? (
              <Button component={Link} to="/admin/manage-program-enrollments" variant="contained">
                Back to enrollments
              </Button>
            ) : (
              <Button component={Link} to="/programs" variant="contained">
                Browse programs
              </Button>
            )}
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default ProgramFail;
